import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';

import {
  KalturaClient,
  AccessControlListAction,
  KalturaAccessControlFilter,
  KalturaAccessControl,
  KalturaFilterPager,
  KalturaAccessControlListResponse,
} from 'kaltura-ngx-client';

import { cancelOnDestroy, tag } from '@kaltura-ng/kaltura-common';
import { AppEventsService } from '../app-events';
import { AccessControlProfileUpdatedEvent } from '../events/access-control-profile-updated.event';
import { PartnerProfileStore } from '../partner-profile';

@Injectable()
export class AccessControlProfileStore extends PartnerProfileStore implements OnDestroy {
  private _cachedProfiles$: Observable<{ items: KalturaAccessControl[] }>;

  constructor(private _kalturaServerClient: KalturaClient, _appEvents: AppEventsService) {
    super();

    _appEvents
      .event(AccessControlProfileUpdatedEvent)
      .pipe(cancelOnDestroy(this))
      .subscribe(() => {
        this._clearCache();
      });
  }

  ngOnDestroy() {}

  private _clearCache(): void {
    this._cachedProfiles$ = null;
  }

  public get(): Observable<{ items: KalturaAccessControl[] }> {
    if (!this._cachedProfiles$) {
      // execute the request
      this._cachedProfiles$ = this._buildGetRequest()
        .pipe(cancelOnDestroy(this))
        .map((response) => ({ items: response ? response.objects : [] }))
        .catch((error) => {
          // re-throw the provided error
          this._cachedProfiles$ = null;
          return Observable.throw(new Error('failed to retrieve access control profiles list'));
        })
        .publishReplay(1)
        .refCount();
    }

    return this._cachedProfiles$;
  }

  private _buildGetRequest(): Observable<KalturaAccessControlListResponse> {
    const filter = new KalturaAccessControlFilter({ orderBy: '-createdAt' });
    const pager = new KalturaFilterPager({ pageSize: 1000 });
    return <any>this._kalturaServerClient.request(new AccessControlListAction({ filter, pager }));
  }
}
